"use client";

import { c as _c } from "react/compiler-runtime";
import { loadStripe } from "@stripe/stripe-js/pure";
import { useEffect, useState } from "react";
import type { Stripe } from "@stripe/stripe-js";
let stripePromise: Promise<Stripe | null> | null = null;
function getStripePromise() {
  stripePromise ??= loadStripe(process.env.NODE_ENV === "development" ? "pk_test_51RRXM1CYKGHizcWTfXxFSEzN8gsUQkg2efi2FN5KO2M2hxdV9QPCjeZMPaZQHSAatxpK9wDcSeilyYU14gz2qA2p00R4q5xU1R" : "pk_live_51RRXLsEAkKxa3kRayCPr9oW8dUp7mIzwev1FVpM3jpKU3StLaaiKvXCEPkewabL5hRip4IXLzFlFTLC4RpFWRknN00lX2vgZHP");
  return stripePromise;
}

// Pass enabled: false to skip loading Stripe.js entirely until the caller
// actually needs it — the script is ~200KB and phones home on load.
export function useStripe(t0) {
  const $ = _c(7);
  const enabled = t0 === undefined ? true : t0;
  const [stripe, setStripe] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  let t1;
  let t2;
  if ($[0] !== enabled) {
    t1 = () => {
      if (!enabled) {
        return;
      }
      getStripePromise().then(stripeInstance => {
        setStripe(stripeInstance);
        setIsLoading(false);
      }).catch(err => {
        setError(err);
        setIsLoading(false);
      });
    };
    t2 = [enabled];
    $[0] = enabled;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== error || $[4] !== isLoading || $[5] !== stripe) {
    t3 = {
      stripe,
      isLoading,
      error
    };
    $[3] = error;
    $[4] = isLoading;
    $[5] = stripe;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
export function loadStripeNow() {
  return getStripePromise();
}